import { store } from "jiffy-store";
import { track } from "jiffy-analytics";
import loadPrices from "components/jiffy/product-details/load-prices";

const setPrintClassName = hidePrices => {
  const $container = document.querySelector(".js-product-color-picker-print");
  $container?.classList.toggle("product-color-picker--hidden-amounts", hidePrices);
};

const setVisibility = (containerName, isHidden) => {
  const $softnewssBlocks = document.querySelectorAll(containerName);
  $softnewssBlocks.forEach($el => {
    $el.classList.toggle("hidden", isHidden);
  });
};

const getTrackVisibilityValue = value => (value ? "hidden" : "visible");

const trackEvent = () => {
  track("colors_print_page_visit", {
    brand: getTrackVisibilityValue(window.hideBrand),
    materials: getTrackVisibilityValue(window.hideMaterials),
    prices: getTrackVisibilityValue(window.hidePrices),
    softness_score: getTrackVisibilityValue(window.hideSoftness),
    version: "v1"
  });
};

document.addEventListener("DOMContentLoaded", () => {
  setPrintClassName(window.hidePrices);
  setVisibility(".js-product-color-picker-material-container", window.hideMaterials);
  setVisibility(".js-product-color-picker-softness-container", window.hideSoftness);
  setVisibility(".js-product-color-picker-brand-container", window.hideBrand);
  setVisibility(".js-product-color-info-section-container", window.hideMaterials);
  trackEvent();

  if (window.hidePrices) {
    window.print();
  } else {
    let loadedPrices = false;
    loadPrices();
    store.pdp.changed((_, { data }) => {
      if (data.loadedPrices && !loadedPrices) {
        window.print();
        loadedPrices = true;
      }
    });
  }
});
